module.exports = __webpack_public_path__ + "static/media/herHyg.f1c2d15b.png";